<div>
    <!-- Enabled -->
    <div class="row">
        <div class="col-sm-6">
            <div class="form-group">
                <div class="control control-checkbox lg control-form-group">
                    <label>
                        Enabled
                        <input type="checkbox" 
                            [disabled]="isReadOnly()"
                            [(ngModel)]="alertConfiguration().IsEnabled" />
                        <i></i>
                    </label>
                </div>
            </div>
        </div>
    </div>

    <app-layout-row>
        <app-layout-column [width]="12" offset="0">
            <ep-schedule-item #alertSchedule 
                [(scheduleItem)]="alertConfiguration().ScheduleItem" [hideTriggerEnd]="false" [readonly]="isReadOnly()" 
                [showDates]="false" [validateTriggerTimes]="true" [requireWeekdaySelection]="true"
                (scheduleItemChange)="onScheduleTriggerChange($event)">
            </ep-schedule-item>
            @if(selectedTriggerCount() > 0) { <hr> }
        </app-layout-column>
    </app-layout-row>

    <h2>Alert threshold</h2>
    <div class="row">
        <div class="col-sm-6">
            <div class="form-group">
            <label title="An alert will be sent if the required number of documents is not exchanged within the specified trigger periods.">Number of documents
                <input type="number"
                    [disabled]="isReadOnly()"
                    [(ngModel)]="alertConfiguration().RequiredNumberOfDocuments" 
                    class="form-control" 
                    required>
            </label>
            </div>
        </div>
    </div>

    <!-- Stakeholder + Email options -->
    <div class="row">
        <div class="col-sm-6">
            <h2>Notify Stakeholder</h2>
            <div class="form-group">
                <label>Stakeholder</label>
                <select class="form-control" 
                    [disabled]="isReadOnly()"
                    [ngModel]="alertConfiguration().StakeholderId"
                    (ngModelChange)="onStakeholderChanged($event)"> 
                    <option [ngValue]="0">None</option>
                    @for (item of stakeholders(); track $index) 
                    {
                        <option [ngValue]="item.StakeholdersId">{{ item.Name }}</option>
                    }   
                </select>
            </div>

            <!--Notify stakeholder's email-->
            <div class="form-group">
                <div class="alert-configuration-notify-stakeholder"></div>
                <div class="control control-checkbox inline-checkbox form-group">
                    <label>
                        Notify stakeholder's normal email
                        <input type="checkbox" 
                            [disabled]="true"
                            [ngModel]="alertConfiguration().NotifyStakeholder"
                            (ngModelChange)="alertConfiguration().NotifyStakeholder = $event" />
                        <i></i>
                    </label>
                </div>
            </div>

            <!--Notify stakeholder's urgent email-->
            <div class="form-group">
                <div class="alert-configuration-is-urgent"></div>
                <div class="control control-checkbox inline-checkbox form-group">
                    <label>
                        Notify stakeholder's urgent e-mail
                        <input type="checkbox" 
                            [disabled]="isReadOnly() || alertConfiguration().StakeholderId === 0"
                            [ngModel]="alertConfiguration().IsUrgent"
                            (ngModelChange)="alertConfiguration().IsUrgent = $event" />
                        <i></i>
                    </label>
                </div>
            </div>
            
            
            <h2>Notify Partners</h2>
            @if (senderPartner() !== null)
            {
                <div class="form-group">
                    <label title="Select one ore more. Contacts listed below will be notified.">Sending Partner</label>
                    <dx-tag-box [disabled]="isReadOnly()" [dataSource]="contactTypes()" [acceptCustomValue]="false"
                        [showSelectionControls]="true" [ngModel]="alertConfiguration().SenderPartnerContactTypes"
                        (ngModelChange)="onPartnerContactTypesChange(PartnerContactTypesEnum.Sender, $event)"
                        placeholder="Select contact types" displayExpr="Name" valueExpr="Id">
                    </dx-tag-box>
                </div>
                <div class="container-fixed" style="margin-bottom: 20px;">
                    <div class="row">
                        <div class="col-sm-12">
                            <dx-data-grid biz-grid class="alertContactTypes-biz-grid" [selection]='{ mode: "none" }' [dataSource]='selectedSenderPartnerContacts()'
                                [bizSetColumnChooser]="false" [bizSetGroupPanel]="false" [bizSetAllowColumnReordering]="false"
                                [bizSetSearchPanel]="false" [bizSetPager]="false" [bizHideSelectedRowsCompnent]="true">
                                <dxo-column-fixing [enabled]="true"></dxo-column-fixing>
                                <dxo-group-panel [visible]="false"></dxo-group-panel>
                
                                <dxi-column dataField="ContactName" caption="Name" dataType="string"
                                    sortOrder="asc"></dxi-column>
                                <dxi-column dataField="Email" caption="Email" dataType="string"></dxi-column>
                                <dxi-column dataField="Type" caption="Types" dataType="string"></dxi-column>
                            </dx-data-grid>
                        </div>
                    </div>
                </div>   
            }

            <div class="form-group">
                <label title="Select one ore more. Contacts listed below will be notified.">Receiving Partner</label>
                <dx-tag-box [disabled]="isReadOnly()" [dataSource]="contactTypes()" [acceptCustomValue]="false"
                    [showSelectionControls]="true" [ngModel]="alertConfiguration().ReceivingPartnerContactTypes"
                    (ngModelChange)="onPartnerContactTypesChange(PartnerContactTypesEnum.Receiving, $event)"
                    placeholder="Select contact types" displayExpr="Name" valueExpr="Id">
                </dx-tag-box>
            </div>
            <div class="container-fixed" style="margin-bottom: 20px;">
                <div class="row">
                    <div class="col-sm-12">
                        <dx-data-grid biz-grid class="alertContactTypes-biz-grid" [selection]='{ mode: "none" }' [dataSource]='selectedReceivingPartnerContacts()'
                            [bizSetColumnChooser]="false" [bizSetGroupPanel]="false" [bizSetAllowColumnReordering]="false"
                            [bizSetSearchPanel]="false" [bizSetPager]="false" [bizHideSelectedRowsCompnent]="true">
                            <dxo-column-fixing [enabled]="true"></dxo-column-fixing>
                            <dxo-group-panel [visible]="false"></dxo-group-panel>
            
                            <dxi-column dataField="ContactName" caption="Name" dataType="string"
                                sortOrder="asc"></dxi-column>
                            <dxi-column dataField="Email" caption="Email" dataType="string"></dxi-column>
                            <dxi-column dataField="Type" caption="Types" dataType="string"></dxi-column>
                        </dx-data-grid>
                    </div>
                </div>
            </div>
        </div> 
        
        <div class="col-sm-6">
            <h2>Email options</h2>
            <div class="form-group">
                <div class="control control-checkbox lg control-form-group">
                    <label>
                        Override default email settings
                        <input type="checkbox" 
                            [disabled]="isReadOnly()"
                            [ngModel]="alertConfiguration().OverrideMailTemplate" 
                            (ngModelChange)="onOverrideTemplateChange($event)" />
                        <i></i>
                    </label>
                </div>
            </div>
            <app-mail-template-edit 
                [(subject)]="alertConfiguration().OverrideMailSubject" 
                [(body)]="alertConfiguration().OverrideMailBody" 
                [macros]="macroDefinitions()" 
                [enabled]="alertConfiguration().OverrideMailTemplate && !isReadOnly()" [extendedToolbar]="false">
            </app-mail-template-edit>
        </div>    
    </div>
</div>
